import { IDestroyOptions } from "pixi.js";
import { ICanvasScaler } from "../../../../../../canvas/ICanvasScaler";
import { BaseView } from "../../../../../../scene/viewable/BaseView";
import { PromiseCompletionSource } from "../../../../../../shared/async/PromiseCompletionSource";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { IFocusable } from "../../../../layers/IFocusable";
import { IWalletConnectPage } from "./pages/IWalletConnectPage";
import { SuccessWalletConnect } from "./pages/SuccessWalletConnect";
import { FadeScreen } from "../../../../game/components/FadeScreen";
import { ButtonWithScaleAnimation } from "../../../../common/components/ButtonWithScaleAnimation";
import { WalletConnectMessageOptions } from "../WalletConnectMessagesScene";
import { WalletConnectState } from "../WalletConnectState";
import { FailedWalletConnect } from "./pages/FailedWalletConnect";

export class WalletConnectMessagesView extends BaseView<void> implements IFocusable {
    public readonly focusable: boolean = true;

    private readonly commonResources: CommonResourcesPackage;
    private readonly canvasScaler: ICanvasScaler;

    private fade: FadeScreen;
    private closeButton: ButtonWithScaleAnimation;
    private currentPage: IWalletConnectPage;
    private options: WalletConnectMessageOptions<WalletConnectState>;

    public constructor(
        pcs: PromiseCompletionSource<void>,
        commonResources: CommonResourcesPackage,
        options: WalletConnectMessageOptions<WalletConnectState>,
        canvasScaler: ICanvasScaler
    ) {
        super(pcs);
        this.commonResources = commonResources;
        this.options = options;
        this.canvasScaler = canvasScaler;

        this.build();
        this.closeButton.onUp.once(this.close, this);
    }

    public async start(): Promise<void> {
        switch (this.options.state) {
            case WalletConnectState.CONNECTED:
                this.currentPage = this.addChild(new SuccessWalletConnect(this.commonResources, this.options.walletType, this.canvasScaler));
                await Promise.all([this.fade.fadeIn(), this.currentPage.show()]);
                break;
            case WalletConnectState.ALREADY_CONNECTED:
                this.currentPage = this.addChild(new FailedWalletConnect(this.commonResources, this.canvasScaler));
                await Promise.all([this.fade.fadeIn(), this.currentPage.show()]);
                break;
        }
    }

    private build(): void {
        this.fade = new FadeScreen(0.5, 0, 0.8, this.canvasScaler.referenceWidth, this.canvasScaler.referenceHeight);
        this.fade.eventMode = "static";
        this.addChild(this.fade);

        this.closeButton = new ButtonWithScaleAnimation(this.commonResources.assets_common_x_png);
        this.closeButton.defaultView.width = this.closeButton.defaultView.height = 72;
        this.closeButton.position.set((this.canvasScaler.referenceWidth - this.closeButton.width) * 0.5, 1550);
        this.addChild(this.closeButton);
    }

    private async close(): Promise<void> {
        await Promise.all([this.fade.fadeOut(), this.currentPage.hide()]);
        this.operationControls.complete();
    }
}